import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateRoleForm from "../../forms/CreateOrUpdateRoleForm";

interface CreateRoleModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateRoleModal: React.FC<CreateRoleModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Create New Role"
      width="sm"
      loading={loading}
    >
      <CreateOrUpdateRoleForm loading={loading} error={error} />
    </AppModal>
  );
};

export default CreateRoleModal;
